import React from 'react'
import { connect } from 'react-redux';
import { Badge } from 'react-bootstrap'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import UnsubscribeButton from '../UnsubscribeButton'
import DetailsButton from '../DetailsButton';
import EnableStudentButton from '../EnableStudentButton'
import { Link } from '../Link'
import { DEPARTMENT_HEADS } from '../../constants/roles';

 const ListUnenrolledStudents = ({
  majors,
  auth,
  records,
  allowEnrollmentStateToggle = true
}) => {

  const { user } = auth

  /** Here are all the columns */
  const columns = [
    {
      dataField: 'numero_de_control',
      text: 'Número de control'
    },
    {
      dataField: 'nombre',
      text: 'Nombre'
    },
    {
      dataField: 'carrera',
      text: 'Carrera',
      formatter: (cell) => {
        const major = majors.length && majors.find( ({ value }) =>  value == cell)
        return major.label
      },
    },
    {
      dataField: 'documentacion',
      text: 'Documentación',
      formatter: cell => (<Badge variant={cell === 2? 'warning' : !cell ? 'info' : 'success'}>
        {
           cell === 2 ? 'Faltan documentos' : !cell ? 'Listo para revisar' : 'Aprobado y validado'
        }
        </Badge>),
    },
    {
      dataField: 'inscrito',
      text: 'Estatus',
      formatter: cell => <Badge variant={cell ? 'success' : 'danger'}>{ cell ? 'Inscrito' : 'No Inscrito'}</Badge> ,
    },
    {
      dataField: 'tiene_documento_pendiente',
      text: '¿Documento pendiente?',
      formatter: cell =>  cell ? 'Si' : 'No',
    },
    {
      dataField: 'corrimiento',
      text: 'Corrimiento',
      formatter: cell =>  cell ? 'Si' : 'No',
    }, 
    {
      dataField: 'tardias',
      text: 'Tardias',
      formatter: cell =>  cell ? 'Si' : 'No',
    },  
    {
      dataField: 'action',
      text: 'Acciones',
    }
];


/** serialize all dataset */
  const students = records.map( ({
    inscripcion: { carrera, documentacion, corrimiento, tardias, numero_de_control, inscrito, tiene_documento_pendiente},
    nombre,
    primer_apellido,
    segundo_apellido,
    slug,
    deleted_at
  }) => {
    return {
          numero_de_control: numero_de_control,
          nombre: `${nombre} ${primer_apellido} ${segundo_apellido}`,
          carrera: carrera.id,
          documentacion: documentacion === null ? 2 : documentacion ,
          inscrito: inscrito,
          tiene_documento_pendiente: tiene_documento_pendiente ? 1 : 0,
          corrimiento: corrimiento,
          tardias: tardias,
          action: deleted_at === null 
            ? <>
                <DetailsButton controlNumber={numero_de_control} />
                { (DEPARTMENT_HEADS.includes(user.role)) && (
                  <>
                    {allowEnrollmentStateToggle && <UnsubscribeButton slug={slug} />}
                    <Link to={`../aspirante/${numero_de_control}`} variant='info'>
                      <i className='fa fa-edit'></i>
                    </Link>
                  </>
                )}
            </>
            : allowEnrollmentStateToggle && <EnableStudentButton slug={slug}/>
        }
  })



  return (
    <BootstrapTable 
      bootstrap4 keyField='numero_de_control'
      data={ students }
      columns={ columns }
    /> 
  )

}

const mapStateToProps = ({ auth }) => ({ 
  auth : auth
})


export default connect(mapStateToProps, null)(ListUnenrolledStudents)

